export const Footer = () => {
  return (
    <nav className="bg-white shadow-md z-10">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-14">
        <div className="flex justify-between h-10">
          {/* <div className="flex justify-between"> */}
            <div className="flex items-center space-x-2">
                <span className=" text-gray-600 text-xs font-medium">Copyright 2025</span>
                <span className=" text-gray-700 text-xs font-bold">IamInfinite</span>
                <span className=" text-gray-600 text-xs font-medium">All rights reserved</span>
            </div>
            <div className="flex items-center space-x-2">
                <span className=" text-gray-600 text-xs font-medium">Terms & Conditions Privacy Policy</span>
            </div>
          </div>
          
        {/* </div> */}
      </div>
    </nav>
  );
}